import type { DocumentProcessingStatus } from '../../services/documents/documentTypes';

export type {
  DocumentDeleteResponse,
  DocumentHealthResponse,
  DocumentProcessingStatus,
  DocumentStatusResponse,
  DocumentUploadResult,
} from '../../services/documents/documentTypes';

export type UploadedDocument = {
  documentId: string;
  filename: string;
  customerId: number;
  status: DocumentProcessingStatus;
  allowedRoles?: string[];
  createdAt?: string;
  updatedAt?: string;
};

/** @deprecated Use UploadedDocument */
export type ProcessingDocument = UploadedDocument;

export interface DocumentsStore {
  uploadedDocuments: UploadedDocument[];
  isUploading: boolean;
  isLoadingDocuments: boolean;
}

export enum DocumentsActionTypes {
  SET_UPLOADED_DOCUMENTS = 'SET_UPLOADED_DOCUMENTS',
  ADD_UPLOADED_DOCUMENTS = 'ADD_UPLOADED_DOCUMENTS',
  UPDATE_UPLOADED_DOCUMENT_STATUS = 'UPDATE_UPLOADED_DOCUMENT_STATUS',
  REMOVE_UPLOADED_DOCUMENT = 'REMOVE_UPLOADED_DOCUMENT',
  SET_DOCUMENTS_UPLOADING = 'SET_DOCUMENTS_UPLOADING',
  SET_DOCUMENTS_LOADING = 'SET_DOCUMENTS_LOADING',
}

export type DocumentsAction =
  | {
      type: DocumentsActionTypes.SET_UPLOADED_DOCUMENTS;
      payload: UploadedDocument[];
    }
  | {
      type: DocumentsActionTypes.ADD_UPLOADED_DOCUMENTS;
      payload: UploadedDocument[];
    }
  | {
      type: DocumentsActionTypes.UPDATE_UPLOADED_DOCUMENT_STATUS;
      payload: { documentId: string; status: DocumentProcessingStatus };
    }
  | {
      type: DocumentsActionTypes.REMOVE_UPLOADED_DOCUMENT;
      payload: string;
    }
  | {
      type: DocumentsActionTypes.SET_DOCUMENTS_UPLOADING;
      payload: boolean;
    }
  | {
      type: DocumentsActionTypes.SET_DOCUMENTS_LOADING;
      payload: boolean;
    };
